import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2aa44518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-reservoir" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "基本信息", -1))
const _hoisted_8 = { class: "descriptions-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "水库类别:", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "descriptions-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在乡镇:", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "descriptions-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "总库容（万m³）:", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "descriptions-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "死库容（万m³）:", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "descriptions-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "水质监测", -1))
const _hoisted_22 = { class: "descriptions-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测类型:", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "descriptions-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测方式:", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "descriptions-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "目标水质:", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "descriptions-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "当前水质：", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "descriptions-item2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "主要污染物：", -1))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "descriptions-group" }
const _hoisted_38 = { class: "video-box descriptions-group" }

import Video from 'video.js'
import { toRefs, nextTick, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue'
import { ref } from 'vue-demi'
const max = 1

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogReservoir',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)
const { proxy } = getCurrentInstance()
const chart = ref()
const videoShow = ref(false)
const video = ref()
const videoUrl = ref()
const videoList = ref([])
let player: {
  pause(): unknown
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}
const myChart = {}
const testY = [0.12, '1', '', 0.15, 0.12, 0.25, 0.1, 0.41, 0.5, 0.2, 0.1, 0.4]
const testX = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
// if (myChart) {
//   myChart.clear()
// }
const option = {
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'item',
  },
  grid: {
    show: true,
    top: 40,
    left: '6%',
    right: 45,
    bottom: 20,
    borderWidth: '0',
  },
  yAxis: {
    name: 'mg/L',
    nameTextStyle: {
      fontSize: 14,
      color: '#ffffff',
    },
    show: true,
    type: 'value',
    min: 0,
    max,
    splitLine: {
      show: true,
      lineStyle: {
        width: 2,
        dashOffset: 10,
        type: 'dashed',
        color: 'rgba(230, 247, 255, 0.2)',
      },
    },
    axisLabel: {
      formatter: '{value}',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  xAxis: {
    data: testX,
    boundaryGap: false,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#ffffff',
      },
    },

    axisLabel: {
      type: 'category',
      formatter: '{value}',
      // rotate: '45',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  series: [
    {
      name: 'title',
      type: 'line',
      color: '#09CEA5',
      smooth: false, // 关键点，为true是不支持虚线，实线就用true
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2,
            type: 'dotted', // 'dotted'虚线 'solid'实线
          },
        },
      },
      markLine: {
        symbol: 'none',
        data: [
          {
            yAxis: 0.6,
            valueIndex: 1,
            // coord:['60','7'],
            lineStyle: {
              normal: {
                color: '#fd0',
                type: 'dashed',
              },
            },
            label: {
              normal: {
                // show: false,
                color: '#fd0',
                // position: 'insideEndBottom',
                formatter: '标准值',
              },
            },
          },
        ],
      },
      lineWidth: 2,
      symbol: '',
      symbolSize: 8,
      data: testY,
    },
  ],
}

const videoChange = (data) => {
  player.src({ src: data })
  player.play()
}

const showVideoBox = () => {
  videoShow.value = !videoShow.value
  if (videoShow.value) {
    if (player) {
      player.play()
    } else {
      const option = {
        muted: false,
        // controls: true,
        loop: false,
        autoplay: false,
        sources: [
          {
            type: '',
            src: videoUrl.value, // url地址
          },
        ],
        notSupportedMessage:
          videoList && videoList.length > 0
            ? '此视频暂无法播放，请稍后再试'
            : '该站点暂时未接入视频',
      }
      // 初始化的时候标签默认都是显示的
      player = Video(video.value, option, () => {
        player.on('error', () => {
          player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
          console.log('视频加载错误')
        })
      })
      player.play()
    }
  } else {
    player.pause()
  }
}

nextTick(() => {
  // myChart.setOption(option)
})
onMounted(() => {
  for (let i = 0; i < data.value.videoStream.length; i++) {
    videoList.value.push({ label: '视频' + (i + 1), value: data.value.videoStream[i] })
  }
  if (videoList.value[0]) {
    videoUrl.value = videoList.value[0].value
  }
  // myChart = proxy.$echarts.init(chart.value)
})

onBeforeUnmount(() => {
  setTimeout(() => {
    if (player) {
      player.dispose()
    }
  }, 200)
})

return (_ctx: any,_cache: any) => {
  const _component_n_select = _resolveComponent("n-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).hkmc || '-'), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["btn", _unref(videoShow) ? 'active' : '']),
        onClick: showVideoBox
      }, "视频", 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(data).hkgm || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(data).xzqhmc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(data).zkr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(data).skr || '-'), 1)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(data).zcxsw || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data).ymqjxgc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(data).dbjsydmj || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(data).skglfwmj || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(data).skbhfwmj || '-'), 1)
          ])
        ], 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", {
            ref_key: "chart",
            ref: chart,
            class: "chart"
          }, null, 512)
        ], 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_38, [
          _createVNode(_component_n_select, {
            value: _unref(videoUrl),
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(videoUrl) ? (videoUrl).value = $event : null)),
              videoChange
            ],
            size: "tiny",
            options: _unref(videoList)
          }, null, 8, ["value", "options"]),
          _createElementVNode("video", {
            ref_key: "video",
            ref: video,
            controls: "",
            autoplay: "",
            class: "video video-js vjs-default-skin vjs-big-play-centered"
          }, null, 512)
        ], 512), [
          [_vShow, _unref(videoShow)]
        ])
      ])
    ])
  ]))
}
}

})